export default "__VITE_ASSET__dO3aHSzJ__"